import React from 'react';
import { cn } from '../../../lib/utils';

const EventTypeCards = ({
  value = [],
  onChange,
  className = '',
  disabled = false
}) => {
  const eventTypes = [
    {
      id: 'festivals',
      label: '🎪 Festivals',
      description: 'Multi-day music events'
    },
    {
      id: 'concerts',
      label: '🎤 Concerts / Gigs',
      description: 'Live music performances'
    },
    {
      id: 'clubs',
      label: '🎧 Club nights',
      description: 'Raves & DJ sets'
    },
    {
      id: 'other',
      label: '🎵 Other',
      description: 'Everything else'
    }
  ];

  const handleToggle = (eventId) => {
    if (disabled) return;

    const newValue = value.includes(eventId)
      ? value.filter(id => id !== eventId)
      : [...value, eventId];

    onChange?.(newValue);
  };

  return (
    <div className={cn("space-y-2", className)}>
      {eventTypes.map((event) => {
        const isSelected = value.includes(event.id);

        return (
          <button
            key={event.id}
            type="button"
            onClick={() => handleToggle(event.id)}
            disabled={disabled}
            className={cn(
              "w-full text-left px-4 py-3 rounded-lg",
              "border transition-all duration-200",
              "border-white/20",
              "flex items-center gap-3",
              isSelected
                ? "bg-white/15 border-white/30"
                : "hover:bg-white/10",
              disabled && "opacity-50 cursor-not-allowed"
            )}
            aria-label={`${isSelected ? 'Deselect' : 'Select'} ${event.label}`}
            aria-pressed={isSelected}
          >
            <span className="text-[30px] leading-none flex-shrink-0">
              {event.label.split(' ')[0]}
            </span>
            <div className="flex-1">
              <div className="text-white/90 text-[15px] leading-relaxed font-medium">
                {event.label.substring(event.label.indexOf(' ') + 1)}
              </div>
              {event.description && (
                <div className="text-white/60 text-[13px] mt-0.5">
                  {event.description}
                </div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default EventTypeCards;